import { PhoneNumberUtil, PhoneNumberFormat, PhoneNumber } from 'google-libphonenumber';
const phoneUtil = PhoneNumberUtil.getInstance();

/**
 * Returns a user-friendly display format for a sanitized phone number.
 * Always uses INTERNATIONAL format, e.g. "+54 358 402 2664"
 */
export const formatPhoneForDisplay = (number: string): string => {
  if (!number || !number.trim()) return number;

  try {
    const parsed: PhoneNumber = phoneUtil.parse(number, undefined);

    if (!phoneUtil.isValidNumber(parsed)) {
      // If not valid, just return as-is
      return number;
    }

    // Always use INTERNATIONAL format
    return phoneUtil.format(parsed, PhoneNumberFormat.INTERNATIONAL);
  } catch (e) {
    return number;
  }
};
